<template>
  <div class="search-page">
    <van-sticky>


      <van-search
          v-model="keyword"
          show-action
          @clear="clear"
          placeholder="请输入搜索关键词"
          @search="onSearch"
      >
        <template #left>
          <van-icon @click.stop="goback" name="arrow-left"/>
          <van-dropdown-menu>
            <van-dropdown-item v-model="productType" :options="types"/>
          </van-dropdown-menu>
        </template>
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div v-if="tags.length>0" class="history">
        <span @click="clearHistory">清空历史</span>
        <div class="tags">
          <div :key="item" v-for="item in tags" class="tag">
            <van-tag
                color="#777"
                text-color="#f7f7f7"

                size="medium"
                type="primary"
                @click="setKeWord(item)"
            >
              {{ item }}
            </van-tag>
          </div>
        </div>
      </div>
      <!--      <div v-if="series.length>0" class="sort-bar">
              <div @click="setSort('new')" :class="['item ', {'active': sortStr=='new'}]">新品</div>
              <div @click="setSort('price desc')" :class="['item ', {'active': sortStr=='price desc'}]">价格降序</div>
              <div @click="setSort('price asc')" :class="['item ', {'active': sortStr=='price asc'}]">价格升序</div>
            </div>-->
    </van-sticky>
    <div class="series">
      <van-empty v-if="series.length==0&&!isLoading&&isQuery" description="没有相应的内容"/>
      <div :key="item" class="item" v-for="item in series">
        <Series :product-type="productType" :info="item"/>
      </div>
    </div>
  </div>
</template>
<script>
import Series from "../components/Series.vue";
import {Dialog} from 'vant';

export default {
  name: "SearchPage",
  components: {
    Series
  },
  data() {
    return {
      category: "",
      types: [],
      keyword: "",
      productType: "",
      isQuery: false,
      sortStr: "new",
      isLoading: false,
      tags: ["艺术", "系列", "古典", "现代"],
      series: []
    };
  },

  mounted() {
    // this.productType = this.$route.query.productType
    this.getHistoryData();
    this.getTypes();
  },
  methods: {
    getTypes() {
      this.$http.post("/public/productTypes", {}).then(res => {
        res = res || []
        res = res.map((item) => {
          return {
            text: item.optionDesc,
            value: item.optionValue
          }
        })
        this.productType = res[0].value
        this.types = res;

      });
    },
    clear() {
      this.keyword = ''
    },
    clearHistory() {
      let that = this
      Dialog.confirm({
        title: '确认提示',
        message: '您确定要删除所有标记吗',
      })
          .then(() => {
            // on confirm
            that.tags = []
            localStorage.setItem('keywords', JSON.stringify(that.tags));
          })
          .catch(() => {
            // on cancel
          });

    },
    setKeWord(tag) {
      this.keyword = tag
      this.onSearch()
    },
    setHistoryData(v) {
      if (!v) {
        return
      }
      this.tags = !this.tags.includes(v) ? [v].concat(this.tags) : this.tags
      localStorage.setItem('keywords', JSON.stringify(this.tags));
    },

    getHistoryData() {
      let tags = JSON.parse(localStorage.getItem("keywords") || '[]');
      this.tags = tags
    },
    goback() {
      history.go(-1)
    },
    getSeriesData() {

      this.isQuery = true;
      this.$http.post("/public/goods", {
        "searchInfo": this.keyword,
        "smartCurtainProductType": this.productType || 'WaiLian'
      }).then(res => {
        this.series = res || []
        if (res.length > 0) {
          this.setHistoryData(this.keyword);
        }

      });

    },

    onSearch(e) {
      this.getSeriesData()
    },
    removeTag(tag) {
      this.tags = this.tags.filter((item) => item != tag)
      localStorage.setItem('keywords', JSON.stringify(this.tags));
    },
    setSort(str) {

      this.sortStr = str;
      this.getSeriesData();
    }
  },
};
</script>
<style scoped>

.search-page {
  background: var(--bg-color);
  min-height: 100vh;
}

.history {
  display: flex;
  flex-wrap: wrap;
  padding: 15px;
  font-size: 14px;
  margin-bottom: -5px;
  background-color: #fff;
}

.history .tags {
  display: flex;
  flex-wrap: wrap;

  margin-left: 10px;
}

.tags .tag {
  margin-right: 5px;
  margin-bottom: 5px;
}

.sort-bar {
  background: #fff;
  display: flex;
  padding: 15px;
  font-size: 14px;
  justify-content: space-between;
}

.sort-bar .item {
  flex: 1;
  text-align: center;
}

.sort-bar .item.active {
  color: var(--primary-color);
}

.search-page .series {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 10px;
  /* justify-content: center; */
}

.series .item {
  margin-bottom: 10px;
  background: #fff;
  flex: 0 0 calc(50% - 10px);
  margin-right: 10px;
  border-radius: 10px;
}

.series .item img {
  max-width: 100%;
}

.van-empty {
  margin: 0 auto;
}

</style>
